import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function useScrollToTop() {
  const { pathname } = useLocation();
  const prevPathname = useRef<string | undefined>(undefined);

  useEffect(() => {
    // 홈페이지에서 다른 페이지로 이동하거나, 홈페이지가 아닌 다른 페이지들 간의 이동일 때만 스크롤을 맨 위로
    if (prevPathname.current !== undefined && pathname !== '/') {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }

    // 현재 경로를 저장
    prevPathname.current = pathname;
  }, [pathname]);
}
